export const aciTriggerContact = {
    iconName: 'trigger-contact',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M11.975 3.911a6.338 6.338 0 00-4.578 1.956 6.31 6.31 0 00-1.74 4.654.456.456 0 11-.91.043 7.209 7.209 0 011.992-5.327A7.237 7.237 0 0111.975 3a7.25 7.25 0 015.237 2.237 7.22 7.22 0 011.543 2.46c.343.915.498 1.848.451 2.824-.028.587-.938.544-.91-.043a6.09 6.09 0 00-.394-2.462 6.309 6.309 0 00-3.437-3.595 6.338 6.338 0 00-2.49-.51zM17.965 16.5c.205.146.312.324.166.529a7.215 7.215 0 01-4.725 2.936.456.456 0 01-.146-.9 6.32 6.32 0 004.129-2.565c.146-.205.371-.147.576 0z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.969 11.008a1.247 1.247 0 00-1.023.937c-.039.16-.045.325-.02.487l.002.005.44 2.939a1.25 1.25 0 001.405 1.05 1.261 1.261 0 001.05-1.428l-.448-2.923a1.249 1.249 0 00-1.406-1.067zm-.125-.903a2.167 2.167 0 012.433 1.84l.448 2.916a2.166 2.166 0 01-1.817 2.466l-.007.001a2.167 2.167 0 01-2.434-1.815v-.001l-.44-2.938a2.15 2.15 0 011.014-2.18c.244-.148.515-.246.796-.288h.007zM18.31 10.128a2.153 2.153 0 012.286.824 2.144 2.144 0 01.371 1.627l-.438 2.921a2.15 2.15 0 01-1.602 1.87 2.16 2.16 0 01-2.66-1.665 2.15 2.15 0 01.005-.858l.445-2.896a2.142 2.142 0 011.593-1.823zm.722.855a1.24 1.24 0 00-1.413 1.098L17.17 15a1.237 1.237 0 00.55 1.34 1.247 1.247 0 001.905-.962l.44-2.94.003-.014a1.233 1.233 0 00-1.037-1.44zM11.976 18.165a.959.959 0 00-.957.962c0 .532.43.96.957.96a.96.96 0 00.956-.96.96.96 0 00-.957-.962zm-1.869.962a1.87 1.87 0 011.869-1.873 1.87 1.87 0 011.868 1.872A1.87 1.87 0 0111.976 21a1.87 1.87 0 01-1.869-1.872z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
